import ThumbnailCardUI from '../../common/ThumbnailCardUI';

export const CardListUI = ({ items, selectedItems, onCardClick }) => {
  if (items.length === 0) {
    return (
      <div className="empty-area">
        <span>{`Currently don't have any renders.`}</span>
      </div>
    );
  }

  return (
    <>
      {items.map((a) => (
        <CardUI key={a.id} item={a} selected={selectedItems.includes(a.id)} onClick={onCardClick} />
      ))}
    </>
  );
};

const CardUI = ({ item = null, selected = false, onClick = () => {} }) => {
  if (!item) return null;
  const { id, thumbnail, render_name, angle_name } = item;

  return (
    <ThumbnailCardUI
      key={id}
      id={id}
      thumbnail={thumbnail}
      className={'smallThumbCard'}
      name={render_name}
      secondLine={angle_name}
      selected={selected}
      imageProps={{
        contain: false,
        rounded: false,
      }}
      onClick={() => onClick(item)}
    />
  );
};
